<template lang="pug">
  .bg-gray-100.min-h-screen
    
    div.p-2(v-if="isMovil")
      div.contenedor-transition-box(
        name="slide-up" 
        is="transition-group"
        v-show='lista.length !== 0', 
        v-infinite-scroll="fetchByScroll" 
        infinite-scroll-disabled="disabledScrollExecute" 
        infinite-scroll-distance="2"
      )
        .mb-2(
          v-for="(item, index) in lista"
          :key="index"
          @click="item.showFull = !item.showFull"
        )
          .flex.justify-center.mb-2(v-if="index === 0 || item.fechaString !== lista[index - 1].fechaString")
            span.text-xxs.rounded-full.px-3.bg-primary.text-white.p-1.rounded.leading-none {{ item.fecha | formatDateDay}}
          .p-4.bg-white.rounded-lg.shadow-xs.relative
            .absolute.top-0.right-0.mt-1.mr-1(@click.stop="irAGasto(item._id)")
              i.fas.fa-edit.text-gray-500
            span.text-sm.font-bold(v-if="item.moneda === 'soles'") S/
            span.text-sm.font-bold(v-if="item.moneda === 'dolares'") $
            span.text-sm.font-bold {{ item.monto | twoDecimals}}
            span.text-sm  en 
            span.text-sm.font-bold {{ item.descripcionTipoGasto }}
            div(v-show="item.showFull")
              .flex.text-xs.mt-4
                .flex.flex-col.flex-1.items-center
                  i.fas.fa-user.text-gray-500
                  span.font-bold.text-xxs {{ item.nombreEmpleado}}
              .mt-3.text-xs.text-left.text-blue-600.bg-blue-200.border.border-blue-400.flex.items-center.p-3.rounded-sm(v-if="item.comentario") {{ item.comentario }}

    div(v-else)
      .filtros.flex.mt-2
        .flex.mb-2.p-2(key="tipo-gasto")
          .flex-1
            span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Tipo gasto
            .relative
              input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
                v-model='descripcionTipoGasto'
                @keyup.down="showPopoverTipoGasto = true"
                @keyup.up="showPopoverTipoGasto = true"
                @keyup.space="showPopoverTipoGasto = true"
                @click="showPopoverTipoGasto = true"
                ref="tipoGasto"
                placeholder="No se han ingresado datos"
              )
              span.absolute.left-0.top-0.pt-2.pl-3
                i.fas.fa-funnel-dollar.text-gray-500
              
              span.absolute.right-0.top-0.pt-2.pr-3(@click="showPopoverTipoGasto = true")
                i.fas.fa-angle-down.text-gray-500
              transition(name="slide-up")
                u-popover(v-if="showPopoverTipoGasto", @close="showPopoverTipoGasto = false")
                  tipo-gasto-seleccionar(
                    @selected="seleccionarTipoGasto"
                    @close="cerrarTipoGasto"
                  )

        .flex.mb-2.p-2(key="empleado")
          .flex-1
            span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Empleado
            .relative
              input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
                v-model='nombreEmpleado'
                @keyup.down="showPopoverEmpleado = true"
                @keyup.up="showPopoverEmpleado = true"
                @keyup.space="showPopoverEmpleado = true"
                @click="showPopoverEmpleado = true"
                ref="empleado"
                placeholder="No se han ingresado datos"
                :disabled="perfil === 'tecnico' || perfil === 'enfermera'"
              )
              span.absolute.left-0.top-0.pt-2.pl-3
                i.fas.fa-user.text-gray-500
              
              span.absolute.right-0.top-0.pt-2.pr-3(@click="showPopoverEmpleado = true", v-if="perfil !== 'tecnico' && perfil !== 'enfermera'")
                i.fas.fa-angle-down.text-gray-500
              transition(name="slide-up")
                u-popover(v-if="showPopoverEmpleado", @close="showPopoverEmpleado = false")
                  empleado-seleccionar(
                    @selected="seleccionarEmpleado"
                    @close="cerrarEmpleado"
                  )
        .flex.mb-2.p-2(key="fechaDesde")
          .flex-1
            span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Fecha desde
            .relative
              input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
                v-model='fechaDesde'
                ref="fechaDesde"
                type="date"
              )
              span.absolute.left-0.top-0.pt-2.pl-3
                i.fas.fa-calendar.text-gray-500
        .flex.mb-2.p-2(key="fechaHasta")
          .flex-1
            span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Fecha hasta
            .relative
              input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
                v-model='fechaHasta'
                ref="fechaHasta"
                type="date"
                placeholder="No se han ingresado datos"
              )
              span.absolute.left-0.top-0.pt-2.pl-3
                i.fas.fa-calendar.text-gray-500
              
        .flex.mb-2.p-2.flex-col.text-xs(key="buttons")
          button.text-primary.border-primary.border.font-bold.py-1.px-2.rounded.cursor-pointer(@click="fetch") Refrescar
          button.mt-1.bg-primary.text-white.font-bold.py-1.px-2.rounded.cursor-pointer(@click="downloadExcel", :disabled="isLoadingExcel") Exportar excel

      table.w-full
        thead.sticky.top-0
          tr.sticky.top-0
            th.w-10.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('fecha')")
              .flex
                span Fecha
                span.pl-1(v-if="sortByName === 'fecha'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('nombreEmpleado')") 
              .flex
                span Empleado
                span.pl-1(v-if="sortByName === 'nombreEmpleado'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('descripcionTipoGasto')") 
              .flex
                span Tipo Gasto
                span.pl-1(v-if="sortByName === 'descripcionTipoGasto'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('moneda')") 
              .flex
                span Moneda
                span.pl-1(v-if="sortByName === 'moneda'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('monto')") 
              .flex
                span Monto
                span.pl-1(v-if="sortByName === 'monto'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer
              .flex
                span Comentario
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('fechaCreacion')") 
              .flex
                span Fecha Creación
                span.pl-1(v-if="sortByName === 'fechaCreacion'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('fechaModificacion')") 
              .flex
                span Fecha Modificación
                span.pl-1(v-if="sortByName === 'fechaModificacion'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
        tbody.text-xs(
          name="slide-up" 
          is="transition-group"
          v-show='lista.length !== 0', 
          v-infinite-scroll="fetchByScroll" 
          infinite-scroll-disabled="disabledScrollExecute" 
          infinite-scroll-distance="2"
        )
          tr(v-for="(item, index) in lista" 
            class='hover:bg-gray-100'
            @dblclick='irAGasto(item._id)',
            @contextmenu.prevent="openMenu(item, index)",
            ref="task"
            :key="index + 1"
          )
            td.py-0.px-2.border-b.border-grey-light {{item.fechaString}}
            td.py-0.px-2.border-b.border-grey-light {{item.nombreEmpleado}}
            td.py-0.px-2.border-b.border-grey-light {{item.descripcionTipoGasto}}
            td.py-0.px-2.border-b.border-grey-light {{item.moneda}}
            td.py-0.px-2.border-b.border-grey-light.text-right {{item.monto | twoDecimals}}
            td.py-0.px-2.border-b.border-grey-light {{item.comentario}}
            td.text-center.py-0.px-2.border-b.border-grey-light.text-gray-600
              .flex.flex-col
                span {{item.fechaCreacion | formatDateDay}}
                span.text-xxs {{item.fechaCreacion | formatDateHour}}
            td.text-center.py-0.px-2.border-b.border-grey-light.text-gray-600
              .flex.flex-col
                span {{item.fechaModificacion | formatDateDay}}
                span.text-xxs {{item.fechaModificacion | formatDateHour}}
    
    .m-2.mt-3.text-xs.text-left.text-blue-600.bg-blue-200.border.border-blue-400.flex.items-center.p-3.rounded-sm(v-if="lista.length === 0 && !isLoading") No existe ningún gasto registrado.

    .is-loading.flex.items-center.justify-center.text-primary.text-xl(v-if="isLoading")
      i.fas.fa-spinner.fa-spin

    .fixed.bottom-0.right-0.padding-floating-button
      .flex.justify-center.items-center.p-0.w-10.h-10.bg-primary.rounded-full.mouse.shadow.text-white(@click="nuevoGasto")
        i.fas.fa-plus
    
</template>

<script>
import { apiGet, notify, apiGetExcel } from '../util/general'
import Router from '../router/admin.js'
import Popover from '@/components/c_util_popover.vue'
import EmpleadoSeleccionar from '@/components/c_empleado_seleccionar.vue'
import TipoGastoSeleccionar from '@/components/c_tipo_gasto_seleccionar.vue'
export default {
  name: 'v_cirugia_list',
  components: {
    'u-popover'              : Popover,
    'empleado-seleccionar'   : EmpleadoSeleccionar,
    'tipo-gasto-seleccionar' : TipoGastoSeleccionar
  },
  data () {
    return {
      perfil                : localStorage.getItem('perfil'),
      nombreUsuarioLogueado  : localStorage.getItem('nombre'),
      idLogueado             : localStorage.getItem('_id'),
      isLoading             : false,
      isLoadingExcel        : false,
      skip                  : 0,
      disabledScrollExecute : false,
      noMore                : false,
      isScroll              : false,
      isExcel               : false,
      lista                 : [],
      isMovil               : false,
      window                : { width : 0, height: 0 },
      minWidthMedia         : 800,
      sortByName            : 'fecha',
      sortByType            : 'desc',
      // input empleado
      showPopoverEmpleado   : false,
      idEmpleado            : '',
      nombreEmpleado        : '',
      // input tipo gasto
      showPopoverTipoGasto  : false,
      idTipoGasto           : '',
      descripcionTipoGasto  : '',
      //
      fechaDesde: '',
      fechaHasta: ''
    }
  },
  created () {
    var vm = this

    if (vm.perfil === 'tecnico' || vm.perfil === 'enfermera') {
      vm.idEmpleado     = vm.idLogueado
      vm.nombreEmpleado = vm.nombreUsuarioLogueado
    }

    window.addEventListener('resize', vm.handleResize)
    vm.handleResize()
  },
  destroyed () {
    var vm = this
    window.removeEventListener('resize', vm.handleResize)
  },
  methods: {
    handleResize () {
      console.log('cambio tamaño de la pantalla.. ')
      var vm = this
      vm.window.width  = window.innerWidth;
      // vm.window.height = window.innerHeight;

      var isMovilPrev = vm.isMovil

      if (vm.window.width < vm.minWidthMedia) vm.isMovil = true
      // else if (vm.window.height < vm.minHeightMedia) vm.isMovil = true
      else vm.isMovil   = false

      if (isMovilPrev !== vm.isMovil) vm.fetch()
    },
    // Popover empleado
    seleccionarEmpleado (o) {
      var vm            = this
      vm.idEmpleado           = o._id ? o._id + '' : ''
      vm.nombreEmpleado       = o.nombre
      vm.showPopoverEmpleado  = false
      vm.$refs.empleado.focus()
      vm.actualizar()
    },
    cerrarEmpleado (o) {
      var vm            = this
      vm.showPopoverEmpleado = false
      vm.$refs.empleado.focus()
    },
    //* Popover empleado
    // Popover Tipo Gasto
    seleccionarTipoGasto (o) {
      var vm            = this
      vm.idTipoGasto           = o._id ? o._id + '' : ''
      vm.descripcionTipoGasto       = o.descripcion
      vm.showPopoverTipoGasto  = false
      vm.$refs.tipoGasto.focus()
      vm.actualizar()
    },
    cerrarTipoGasto (o) {
      var vm            = this
      vm.showPopoverTipoGasto = false
      vm.$refs.tipoGasto.focus()
    },
    //* Popover TipoGasto
    actualizar () {
      var vm = this
      vm.fetch()
      // vm.isLoadingActualizar = true
      // if (vm.fechaTerminadoDesde || vm.fechaTerminadoHasta) {
      //   if (!vm.fechaTerminadoDesde) vm.fechaTerminadoDesde = vm.fechaTerminadoHasta
      //   if (!vm.fechaTerminadoHasta) vm.fechaTerminadoHasta = vm.fechaTerminadoDesde
      // }

      // vm.$nextTick(function () {
      //   vm.$refs.tasklista.fetch()
      //   setTimeout(function () { vm.isLoadingActualizar = false; }, 500);
      // })
    },
    fetchByScroll () {
      this.isScroll = true
      this.fetch()
    },
    fetch () {
      var vm                    = this
      vm.disabledScrollExecute  = true
      vm.isLoading              = true
      vm.noMore                 = false

      if (!vm.isScroll) {
        vm.lista  = []
        vm.skip = 0
      }

      var url = '/gasto'

      var obj = {}

      if (vm.isMovil) {
        obj.sortByName = 'fecha'
        obj.sortByType = 'desc'
      } else {
        obj.sortByName = vm.sortByName
        obj.sortByType = vm.sortByType
      }

      if (vm.skip) obj.skip = vm.skip

      obj.idTipoGasto     = vm.idTipoGasto
      obj.idEmpleado      = vm.idEmpleado
      obj.fechaDesde      = vm.fechaDesde
      obj.fechaHasta      = vm.fechaHasta

      apiGet(vm, url, obj, function (data) {
        // console.log(data)
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i])
        }

        if (data.noMore) {
          vm.noMore                = true
          vm.disabledScrollExecute = true
        } else {
          vm.skip = data.newSkip
          vm.disabledScrollExecute = false
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
        vm.disabledScrollExecute = true
      }, function () {
        vm.isLoading = false
        vm.isExcel   = false
        vm.isScroll  = false
      })
    },
    irAGasto (_id) {
      // var vm = this
      Router.push('/gasto/' + _id)
      // vm.$router.go()
    },
    nuevoGasto (_id) {
      // var vm = this
      Router.push('/gasto')
      // vm.$router.go()
    },
    downloadExcel () {
      console.log(this.isExcel)
      var vm = this
      var url = '/gasto/excel'
      vm.isLoadingExcel = true

      var obj = {}
      obj.idTipoGasto     = vm.idTipoGasto
      obj.idEmpleado      = vm.idEmpleado
      obj.fechaDesde      = vm.fechaDesde
      obj.fechaHasta      = vm.fechaHasta

      obj.sortByName    = vm.sortByName
      obj.sortByType    = vm.sortByType
      obj.skip          = 0

      apiGetExcel(vm, url, obj, function (data) {
        console.log('data:', data)
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'})
        var url = window.URL.createObjectURL(blob)

        a.href = url;
        a.download = 'gasto_excel_' + '_' + ((new Date()).getTime()) + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.isLoadingExcel = false
      })
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// v_gasto_list.vue?0349471a